import './App.css';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import LiveDeals from './pages/LiveDeals';
import BecomeMember from './pages/BecomeMember';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ThankYou from './pages/ThankYou';
import FaqPage from './pages/FaqPage';
import InvestNow from './pages/InvestNow';
import MemberRegister from './pages/MemberRegister';


function App() {
  return (
    <div className="App">
      <Routes>
        {/* Home as default landing page */}
        <Route path="/" element={<Home />} />
        <Route path="/live-deals" element={<LiveDeals />} />
        <Route path="/become-member" element={<BecomeMember />} />
        <Route path="/become-member/:deal" element={<BecomeMember />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/faqs" element={<FaqPage />} />
        <Route path="/invest-now" element={<InvestNow />} />
        <Route path="/member-register" element={<MemberRegister />} />

        {/* Redirect any unknown route to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
